/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { fontFamily as getFontFamily, gridSize as getGridSize } from '@atlaskit/theme/constants';
import { h200 } from '@atlaskit/theme/typography';
const fontFamily = getFontFamily();
const gridSize = getGridSize();
const fieldsetLabelStyles = css({
  display: 'inline-block',
  marginTop: 0,
  marginBottom: 0,
  fontFamily: `${fontFamily}`
});
const fieldSetStyles = css({
  marginTop: `${gridSize}px`
}); // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage

const lightH200Styles = css(h200({
  theme: {
    mode: 'light'
  }
})); // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage

const darkH200Styles = css(h200({
  theme: {
    mode: 'dark'
  }
}));

const FieldsetLabel = ({
  children
}) => {
  const {
    mode
  } = useGlobalTheme();
  return jsx("label", {
    css: [mode === 'light' ? lightH200Styles : darkH200Styles, fieldsetLabelStyles]
  }, children);
};
/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */


const Fieldset = ({
  children,
  legend
}) => {
  return jsx("fieldset", {
    css: fieldSetStyles
  }, legend && jsx("legend", null, jsx(FieldsetLabel, null, legend)), children);
};

export default Fieldset;